/* eslint-disable */
import React from "react";
import {
  getFirestore,
  collection,
  getDocs,
  writeBatch,
  doc,
} from "firebase/firestore";
import app from "firebaseConfig";
import { defaultStartingElo } from "constants/gameDefaults";

// eslint-disable-next-line
const appAuthDomain = app._options.authDomain;
const db = getFirestore(app);

function ResetEloButton() {
  const resetElos = async () => {
    const usersCol = collection(db, "users");
    const userSnapshot = await getDocs(usersCol);

    // Split docs into chunks of 500 for batching
    const chunkedDocs = [];
    const batchSize = 500;
    for (let i = 0; i < userSnapshot.docs.length; i += batchSize) {
      chunkedDocs.push(userSnapshot.docs.slice(i, i + batchSize));
    }

    // Process each chunk with a separate batch
    const processChunks = chunkedDocs.map(async (chunk) => {
      const batch = writeBatch(db);
      chunk.forEach((userDoc) => {
        const userRef = doc(db, "users", userDoc.id);
        batch.update(userRef, {
          currentElo: defaultStartingElo,
          elo: defaultStartingElo,
        });
      });
      return batch.commit();
    });

    await Promise.all(processChunks);

    alert("All ELOs have been reset to 1000.");
  };

  const handleResetClick = () => {
    const userInput = prompt(
      "To confirm resetting all ELOs, say that you're sure.",
    );
    if (userInput === "I am really really sure") {
      resetElos();
    } else {
      alert("Operation cancelled.");
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <button onClick={handleResetClick}>Reset ELO System on {appAuthDomain}</button>
    </div>
  );
}

export default ResetEloButton;
